import moment from 'moment-timezone';

// Format the different types of schedule dates:
export const formatLocationDate = date => moment(date).format('M/D/YYYY');
export const formatLocationDateTime = date => moment(date).format('M/D/YYYY h:mm A');
export const formatAbbrExceptionDate = date => moment(date, 'YYYY-MM-DD').format('MM/DD');
export const formatExceptionDate = date => moment(date, 'YYYY-MM-DD').format('M/D/YYYY');
export const formatRecurrenceTime = time => moment(time, 'HH:mm').format('h A');
